var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1502 18.6498L21.6669 33.1331L13.017 24.4832L16.3169 21.1834L21.6669 26.5335L32.8504 15.35L36.1502 18.6498Z",
    fill: "#4AC99B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3334 24C47.3334 36.8865 36.8866 47.3333 24.0001 47.3333C11.1134 47.3333 0.666748 36.8865 0.666748 24C0.666748 11.1133 11.1134 0.666626 24.0001 0.666626C36.8866 0.666626 47.3334 11.1133 47.3334 24ZM42.6667 24C42.6667 34.3093 34.3094 42.6666 24.0001 42.6666C13.6908 42.6666 5.33341 34.3093 5.33341 24C5.33341 13.6906 13.6908 5.33329 24.0001 5.33329C34.3094 5.33329 42.6667 13.6906 42.6667 24Z",
    fill: "#4AC99B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.9085a4c8e5be2c9daa92d6a230a5ddcc.svg";
export { ForwardRef as ReactComponent };